export function breadcrumbsWithoutProduct(breadcrumbs) {
    if (breadcrumbs && breadcrumbs.length) {
        return '/' + breadcrumbs.slice(0, -1).join('/');
    }
    else {
        return '';
    }
}
//# sourceMappingURL=breadcrumbsWithoutProduct.js.map